import PlusLineIcon from "@/components/icons/plus-line"
import { Button } from "@/components/ui/button"
import CustomersTable from "./customers.table"
import { CustomersEditSheet } from "./customers-edit.sheet"
import { useState } from "react"

export default function CustomersHomeScreen() {
  const [editCustomerId, setEditCustomerId] = useState<string | undefined>()

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-row justify-between">
        <div className="text-xl font-semibold">Customers</div>
        <Button
          onClick={() => setEditCustomerId("create")}
          data-testid="create-customer"
        >
          <PlusLineIcon />
          Add Customer
        </Button>
      </div>
      <CustomersTable onEdit={(id) => setEditCustomerId(id)} />
      <CustomersEditSheet
        id={editCustomerId}
        open={editCustomerId !== undefined}
        onDone={() => setEditCustomerId(undefined)}
      />
    </div>
  )
}
